import React, { useEffect, useState } from 'react'
import { Button, Header, Icon } from 'semantic-ui-react'
import Products from '../../Products/Products'
import { setInitialProductValues } from '../../../redux/actions/ui'
import { useDispatch, useSelector } from 'react-redux'
import { ProductForm } from '../../../redux/types/products'
import CopyToClipboard from 'react-copy-to-clipboard'
import { toast } from 'react-toastify'

const getProductName = (product: ProductForm) => {
  return product.name || 'Nameless Product'
}

interface StepThreeProductCreatorProps {
  products: ProductForm[]
}

const StepThreeProductCreator = (props: StepThreeProductCreatorProps) => {
  const [activeRowNumber, setActiveRowNumber] = useState<number | undefined>(undefined)
  const dispatch = useDispatch()
  const createdProducts = useSelector((state: any) => state.batchProductCreator.createdProducts)

  const createdProductsIndices = createdProducts.map(
    (createdProduct: any) => createdProduct.batchCreationIndex
  )

  const [allDone, setAllDone] = useState<boolean>(false)

  useEffect(() => {
    setAllDone(createdProductsIndices.length === props.products.length)
  }, [createdProductsIndices.length, props.products.length])

  useEffect(() => {
    props.products.forEach((_p: any, i: number) => {
      if (
        i === activeRowNumber &&
        createdProductsIndices.indexOf(i) !== -1 &&
        i !== props.products.length - 1
      ) {
        setActiveRowNumber(i + 1)
        dispatch(setInitialProductValues({ values: props.products[i + 1] }))
      }
    })
  }, [activeRowNumber, createdProducts, createdProductsIndices, dispatch, props.products])

  useEffect(() => {
    if (props.products && activeRowNumber === undefined) {
      setActiveRowNumber(0)
      dispatch(setInitialProductValues({ values: props.products[0] }))
    }
  }, [props.products, activeRowNumber, dispatch])

  const getRightSide = () => {
    if (!allDone) {
      return <Products batchCreationIndex={activeRowNumber} />
    } else {
      return (
        <div style={{ marginLeft: '25px' }}>
          <Header as="h2" icon>
            <Icon name="checkmark box" />
            All Done!
            <Header.Subheader>
              You created {createdProductsIndices.length} products!
            </Header.Subheader>
          </Header>
        </div>
      )
    }
  }

  const getCreatedText = (i: number) => {
    const product = createdProducts.find((x: any) => x.batchCreationIndex === i)
    return (
      <CopyToClipboard
        text={product.productId}
        onCopy={() => {
          toast(`Copied ${product.productId} to clipboard`, {
            containerId: 'default',
            toastId: 'copied-batch-product-creator-id',
          })
        }}
      >
        <span>
          {product.productName}: {product.productId}
        </span>
      </CopyToClipboard>
    )
  }

  function getRow(i: number, product: any) {
    return (
      <div
        key={i}
        className="batch-creator-row"
        style={{ marginBottom: '5px' }}
        onClick={() => {
          if (createdProductsIndices.indexOf(i) === -1) {
            setActiveRowNumber(i)
            dispatch(setInitialProductValues({ values: props.products[i] }))
          }
        }}
      >
        {createdProductsIndices.indexOf(i) !== -1 ? (
          <Button fluid color="green">
            <Icon name="copy outline" />
            {getCreatedText(i)}
          </Button>
        ) : (
          <Button fluid primary={i === activeRowNumber}>
            {getProductName(product)}
          </Button>
        )}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flex: '1 0 auto' }}>
      <div
        style={{
          width: 350,
          display: 'flex',
          flexDirection: 'column',
          height: '900px',
          overflowY: 'auto',
          flex: '0 1 auto',
          minWidth: '300px',
          padding: '6px',
        }}
      >
        {props.products && props.products.map((product: any, i: number) => getRow(i, product))}
      </div>
      <div style={{ flex: '1 1 auto' }}>{getRightSide()}</div>
    </div>
  )
}

export default StepThreeProductCreator
